import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import { useEffect, useState } from "react";
import { useCoreApi, useAppState } from "../context/clientHeader";
export function usePerson() {
  var coreApi = useCoreApi();
  var _useAppState = useAppState(),
    personId = _useAppState.personId;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    personData = _useState2[0],
    setPersonData = _useState2[1];
  var loadPerson = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$coreApi$findRe, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return coreApi.findRecord('person', personId);
          case 2:
            _yield$coreApi$findRe = _context.sent;
            data = _yield$coreApi$findRe.data.data;
            _context.next = 6;
            return _Promise.all([coreApi.populateRelationship('consent', 'consent', data), coreApi.populateRelationship('addresses', 'address', data, {
              customQuery: function customQuery() {
                return coreApi.query('address', {
                  'person': data.id
                });
              }
            }), coreApi.populateRelationship('contact_preference', 'contact_preference', data)]);
          case 6:
            setPersonData(data);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadPerson() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    loadPerson();
  }, [personId]);
  return personData;
}
//# sourceMappingURL=usePerson.js.map